import { MouseEvent } from 'react';
import { useDispatch } from 'react-redux';
import { FcLike } from 'react-icons/fc';
import { Button } from '@/components/ui/button';
import { useLikePostMutation, useUnlikePostMutation } from './like.api.slice';
import { setShowLoginDialog } from '../global/global.slice';

function LikeButton({
  liked,
  likes,
  postId,
  size = 'sm',
}: {
  liked: boolean | undefined;
  likes: number;
  postId: string;
  size?: 'sm' | 'md' | 'lg';
}) {
  const dispatch = useDispatch();
  const [like] = useLikePostMutation();
  const [unlike] = useUnlikePostMutation();
  const handleDislike = async (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    await unlike(postId);
  };
  const handleLike = async (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    if (!liked) {
      dispatch(setShowLoginDialog(true));
    }
    await like(postId);
  };

  if (liked) {
    return (
      <Button
        variant="secondary"
        size={size}
        className="flex items-center gap-1 justify-center border-gradient border-[1.5px] text-black text-[13px]"
        onClick={handleDislike}
      >
        <FcLike size="13px" />
        Liked
        <p>{likes}</p>
      </Button>
    );
  }

  return (
    <Button
      variant="outline"
      size={size}
      onClick={handleLike}
      className="flex items-center gap-1 justify-center text-[13px]"
    >
      <FcLike size="13px" />
      Like
      <p>{likes}</p>
    </Button>
  );
}

export default LikeButton;
